import { useState } from "react";
import { suspicions } from "@/mocks/home";

const levelStyle: Record<string, string> = {
  待核实: "bg-accent-100 text-accent-900 border-accent-200",
  中等置信度: "bg-secondary-100 text-secondary-900 border-secondary-200",
  高置信度: "bg-primary-100 text-primary-700 border-primary-200",
};

export default function SuspicionBoard() {
  const [openId, setOpenId] = useState<string | null>(suspicions[0]?.id ?? null);

  return (
    <section id="suspicions" className="w-full bg-background-950 py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-8">
            <div>
              <span className="inline-flex items-center gap-1.5 text-accent-400 text-sm font-medium">
                <i className="ri-question-mark text-base leading-none"></i>
                背景信息疑点
              </span>
              <h2 className="mt-2 font-heading font-bold text-background-50 text-2xl md:text-3xl">
                待核实观察项清单
              </h2>
            </div>
            <p className="text-background-400 text-sm max-w-md">
              这里只放还没被两个以上维度同时证实的观察项，每条都带时间码，点开看拆解说明。
            </p>
          </div>

          <div className="rounded-lg border border-background-800 overflow-hidden">
            {suspicions.map((item, index) => {
              const open = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`bg-background-900/40 ${index > 0 ? "border-t border-background-800" : ""}`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : item.id)}
                    className="w-full flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-900/70 transition-colors"
                  >
                    <span className="hidden sm:inline-flex font-label text-background-500 text-xs w-16 flex-shrink-0">
                      {item.code}
                    </span>
                    <span
                      className={`flex-shrink-0 px-2 py-0.5 rounded border text-xs whitespace-nowrap ${
                        levelStyle[item.level]
                      }`}
                    >
                      {item.level}
                    </span>
                    <span className="flex-1 font-heading font-semibold text-background-50 text-sm md:text-base leading-snug">
                      {item.title}
                    </span>
                    <span className="hidden md:inline-flex items-center gap-1 text-background-500 text-xs whitespace-nowrap">
                      <i className="ri-time-line text-sm leading-none"></i>
                      {item.timecode}
                    </span>
                    <i
                      className={`${
                        open ? "ri-subtract-line" : "ri-add-line"
                      } text-background-300 text-lg leading-none flex-shrink-0`}
                    ></i>
                  </button>

                  {open && (
                    <div className="px-4 md:px-6 pb-5 md:pl-[6.5rem]">
                      <div className="flex flex-wrap items-center gap-2 mb-3">
                        <span className="px-2 py-0.5 rounded bg-background-800 text-background-300 text-xs">
                          {item.type}
                        </span>
                        <span className="md:hidden inline-flex items-center gap-1 text-background-500 text-xs">
                          <i className="ri-time-line text-sm leading-none"></i>
                          {item.timecode}
                        </span>
                      </div>
                      <p className="text-background-300 text-sm leading-relaxed max-w-3xl">
                        {item.detail}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <p className="mt-5 flex items-start gap-2 text-background-500 text-xs md:text-sm leading-relaxed">
            <i className="ri-information-line text-base leading-none mt-0.5 flex-shrink-0"></i>
            疑点不等同于结论。清单里的条目会随新素材补充或下调等级，修订记录单独留痕。
          </p>
        </div>
      </div>
    </section>
  );
}